import typeOf from '../../helpers/typeOf';

// Static meta params
const metaUtmParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
];

const metaParamsCount = 4;

const fnParam = key => {
    key = typeOf.isNumeric(key) ? `param${key + 1}` : key;

    return {
        keyTitle: key,
        visible: false
    };
};

const safeMetaUtmParams = Array.isArray(metaUtmParams) ? metaUtmParams : [];
const safeMetaParamsCount = Number.isFinite(metaParamsCount) ? metaParamsCount : 0;

const metaParams = [
    ...safeMetaUtmParams.map(fnParam),
    ...Array.from(Array(safeMetaParamsCount).keys()).map(fnParam),
];

// Config Data Table Headers
const configDataTable = {
    headers: {
        conversions: [
            {keyTitle: 'id', visible: true},
            {keyTitle: 'createdAt', visible: true},
            {keyTitle: 'updatedAt', visible: false},
            {keyTitle: 'status', visible: true},
            {keyTitle: 'rejectReason', visible: true},
            {keyTitle: 'timeFromTrackToAction', visible: false},
            {keyTitle: 'advCid', visible: false},
            {keyTitle: 'goalTitle', visible: false},
            {keyTitle: 'goalActions', visible: true},
            {keyTitle: 'typeAction', visible: false},
            {keyTitle: 'saleSum', visible: true},
            {keyTitle: 'publisherCreditPerLead', visible: true},
            {keyTitle: 'publisherCreditPerSale', visible: true},
            {keyTitle: 'createdAtTrack', visible: false},
            {keyTitle: 'ip', visible: false},
            ...metaParams,
            {keyTitle: 'actions', visible: true, disabled: true},
        ],
        financeOperations: [
            {keyTitle: 'AdvertiserName', visible: true},
            {keyTitle: 'AdvertiserSite', visible: true},
            {keyTitle: 'Period', visible: true},
            {keyTitle: 'FTDsCount', visible: true},
            {keyTitle: 'CommissionRS', visible: true},
            {keyTitle: 'CommissionCPA', visible: true},
            {keyTitle: 'CommissionTotal', visible: true},
            {keyTitle: 'PaidTotal', visible: true},
            {keyTitle: 'BalanceEndDebt', visible: true},
            {keyTitle: 'BalanceEndHold', visible: true}
        ],
        postbackHistory: [
            {keyTitle: 'id', visible: true},
            {keyTitle: 'conversionPostback', visible: true},
            {keyTitle: 'createdAt', visible: true},
            {keyTitle: 'updatedAt', visible: true},
            {keyTitle: 'status', visible: true},
            {keyTitle: 'locale', keyHint: 'localePostback', visible: true},
            {keyTitle: 'currency', keyHint: 'currencyPostback', visible: true},
            {keyTitle: 'goalTitle', visible: false},
            {keyTitle: 'goalActions', visible: true},
            {keyTitle: 'conversionId', visible: true},
            {keyTitle: 'createdAtConversion', visible: false},
            {keyTitle: 'updatedAtConversion', visible: false},
            {keyTitle: 'conversionStatus', visible: true},
            {keyTitle: 'timeFromTrackToAction', visible: false},
            {keyTitle: 'advCid', visible: false},
            {keyTitle: 'typeAction', visible: false},
            {keyTitle: 'saleSum', visible: false},
            {keyTitle: 'publisherCreditPerLead', visible: false},
            {keyTitle: 'publisherCreditPerSale', visible: false},
            {keyTitle: 'createdAtTrack', visible: false},
            {keyTitle: 'ip', visible: false},
            ...metaParams,
            {keyTitle: 'sendAttempts', visible: true, disabled: true},
            {keyTitle: 'actions', visible: true, disabled: true},
        ]
    }
};

export default configDataTable;
